var $ = require('jquery');
var Backbone = require('backbone');

var TemplateCache = require('TemplateCache');


var ProductView = Backbone.View.extend({

	events: {
	},

	initialize: function() {
		this.listenTo(this.model, "change", this.render);
	},

	render: function() {
		this.el.innerHTML = TemplateCache.render('products-template', this.model.toJSON());

		let detail_request = $("#detail-request");
		if ( !detail_request.length ) {
			console.warn("[products-template] Kein Anfrage-Formular auf dieser Seite gefunden, deaktiviere alle button-inquiry.");
			$('.button-inquiry').remove();
		}
	},
});

module.exports = ProductView;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/miniengine/views/ProductsView.js